const ID = '([0-9a-f]{32}|[0-9a-z]{8})';
const FULL_ID = new RegExp(`^${ID}(:${ID})?$`);

export default function isValidID(value: unknown): value is string {
  return typeof value === 'string' ? FULL_ID.test(value) : false;
}
